import React from 'react';
import { View, Text, ScrollView } from 'react-native';

// Recupera i dati degli assalti generati dalla finestra globale (impostati da ScoreKeeper)
const getDebugAssalti = () => {
  if (typeof window !== 'undefined' && window._debugAssalti) {
    return window._debugAssalti;
  }
  return [];
};

const DebugAssalti = () => {
  const assalti = getDebugAssalti();

  return (
    <ScrollView style={{ flex: 1, padding: 24, backgroundColor: '#fafafa' }}>
      <Text style={{ fontSize: 26, fontWeight: 'bold', marginBottom: 12, color: '#1976d2' }}>Debug Assalti Generati</Text>
      {assalti.length === 0 ? (
        <Text style={{ color: '#888', fontSize: 18 }}>Nessun dato disponibile. Vai su ScoreKeeper per generare gli assalti.</Text>
      ) : (
        <View style={{ borderWidth: 1, borderColor: '#eee', borderRadius: 8, overflow: 'hidden' }}>
          <View style={{ flexDirection: 'row', backgroundColor: '#1976d2' }}>
            <Text style={{ flex: 1, color: '#fff', fontWeight: 'bold', padding: 8 }}>#</Text>
            <Text style={{ flex: 2, color: '#fff', fontWeight: 'bold', padding: 8 }}>Fencer A</Text>
            <Text style={{ flex: 2, color: '#fff', fontWeight: 'bold', padding: 8 }}>Fencer B</Text>
          </View>
          {assalti.map((a, idx) => (
            <View key={idx} style={{ flexDirection: 'row', borderBottomWidth: 1, borderColor: '#eee', backgroundColor: idx % 2 === 0 ? '#f7fafd' : '#fff' }}>
              <Text style={{ flex: 1, padding: 8, color: '#333' }}>{idx + 1}</Text>
              <Text style={{ flex: 2, padding: 8, color: '#1976d2', fontWeight: 'bold' }}>{a.fencerA || a.A || '-'}</Text>
              <Text style={{ flex: 2, padding: 8, color: '#388e3c', fontWeight: 'bold' }}>{a.fencerB || a.B || '-'}</Text>
            </View>
          ))}
        </View>
      )}
      <Text style={{ marginTop: 24, color: '#888', fontSize: 14 }}>
        I dati sono aggiornati ogni volta che accedi a ScoreKeeper. Se non vedi nulla, torna su ScoreKeeper e poi ricarica questa pagina.
      </Text>
    </ScrollView>
  );
};

// --- SCANSIONE: Controlla che tutto il testo sia racchiuso in <Text> ---
// Tutte le visualizzazioni di testo sono già racchiuse in <Text> o sono children di <Text>.
// Nessun caso di testo diretto in <View> trovato (controllo manuale su tutte le sezioni di rendering).

export default DebugAssalti;
